import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { FONT_ENUM } from '../../../types/global/fonts.types';
import { BRAND_LUXE_PRIMARY, BRAND_SURFACE_CONTAINER, BRAND_SURFACE_CONTAINER_LOW } from '../brandDashboardTokens';
import { CAMPAIGN_HOST_SUITE_FEATURES } from './campaignHostTierFeatures';
import { CampaignHostSuiteFeatureList } from './CampaignHostSuiteFeatureList';
import { MIXPANEL_EVENT, trackSubscriptionAction } from '../../../analytics/Mixpanel';

const LOCKED_SUITE_ROWS = CAMPAIGN_HOST_SUITE_FEATURES.map(f => ({
    key: f.key,
    included: false,
}));

export interface CampaignHostSubscriptionEmptyViewProps {
    onExplorePlans: () => void;
}

export function CampaignHostSubscriptionEmptyView({ onExplorePlans }: CampaignHostSubscriptionEmptyViewProps) {
    return (
        <Box sx={{ maxWidth: 640, mx: 'auto' }}>
            <Box
                sx={{
                    position: 'relative',
                    borderRadius: 3,
                    overflow: 'hidden',
                    bgcolor: BRAND_SURFACE_CONTAINER_LOW,
                    mb: 6,
                }}>
                <Box
                    sx={{
                        position: 'absolute',
                        inset: 0,
                        opacity: 0.2,
                        background: `linear-gradient(135deg, ${BRAND_LUXE_PRIMARY}22 0%, transparent 60%)`,
                    }}
                />
                <Box sx={{ position: 'relative', zIndex: 1, p: 5, textAlign: 'center' }}>
                    <Box
                        sx={{
                            width: 80,
                            height: 80,
                            mx: 'auto',
                            mb: 3,
                            borderRadius: '50%',
                            bgcolor: BRAND_SURFACE_CONTAINER,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}>
                        <WorkspacePremiumIcon sx={{ fontSize: 48, color: BRAND_LUXE_PRIMARY }} />
                    </Box>
                    <Typography
                        sx={{
                            fontFamily: FONT_ENUM.MAIN_BOLD,
                            fontSize: 28,
                            fontWeight: 800,
                            color: '#fff',
                            mb: 1.5,
                        }}>
                        Join the Elite
                    </Typography>
                    <Typography sx={{ color: '#adaaaa', fontSize: 16, mb: 4, maxWidth: 360, mx: 'auto' }}>
                        Unlock the full potential of your UGC empire. Scale faster with tools designed for the top 1% of
                        brands.
                    </Typography>
                    <Button
                        type="button"
                        onClick={() => {
                            trackSubscriptionAction(MIXPANEL_EVENT.EXPLORE_SUBSCRIPTION_PLANS_CLICK, {
                                buttonName: 'EXPLORE PLANS',
                                buttonAction: 'EXPLORE_SUBSCRIPTION_PLANS',
                                subscriptionType: 'campaign_host',
                            });
                            onExplorePlans();
                        }}
                        sx={{
                            py: 1.75,
                            px: 5,
                            borderRadius: 99,
                            fontFamily: FONT_ENUM.MAIN_BOLD,
                            fontWeight: 800,
                            textTransform: 'none',
                            fontSize: 16,
                            color: '#392700',
                            background: `linear-gradient(135deg, ${BRAND_LUXE_PRIMARY} 0%, #feb700 100%)`,
                            boxShadow: '0 10px 30px rgba(254,183,0,0.3)',
                        }}>
                        Explore Plans
                    </Button>
                </Box>
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2, px: 1 }}>
                <Typography
                    sx={{
                        fontFamily: FONT_ENUM.MAIN_BOLD,
                        fontSize: 14,
                        letterSpacing: '0.08em',
                        color: BRAND_LUXE_PRIMARY,
                        textTransform: 'uppercase',
                    }}>
                    Premium Suite
                </Typography>
                <Typography
                    sx={{
                        fontSize: 11,
                        fontFamily: FONT_ENUM.MAIN_BOLD,
                        px: 1.5,
                        py: 0.5,
                        borderRadius: 99,
                        bgcolor: BRAND_SURFACE_CONTAINER,
                        color: '#adaaaa',
                    }}>
                    LOCKED
                </Typography>
            </Box>

            <CampaignHostSuiteFeatureList rows={LOCKED_SUITE_ROWS} variant="locked" />

            <Box sx={{ mt: 4, textAlign: 'center' }}>
                <Button
                    endIcon={<OpenInNewIcon sx={{ fontSize: 14 }} />}
                    sx={{
                        color: '#adaaaa',
                        textTransform: 'none',
                        fontSize: 13,
                        '&:hover': { color: BRAND_LUXE_PRIMARY, bgcolor: 'transparent' },
                    }}>
                    Learn about Pro benefits
                </Button>
            </Box>
        </Box>
    );
}
